// f:\checkin\frontend\public\assets\js\scripts.js
// ==========================================================================
// FORM RELATED SCRIPTS
// ==========================================================================

// --- FORM VALIDATION ---
window.initRegisterFormValidation = function initRegisterFormValidation() {
    const form = document.getElementById('registerForm');
    const passwordInput = document.getElementById('password');
    const confirmPasswordInput = document.getElementById('confirm-password');
    const confirmPasswordError = document.getElementById('confirm-password-error');

    if (form && passwordInput && confirmPasswordInput && confirmPasswordError) {
        form.addEventListener('submit', function (event) {
            let isValid = true;
            confirmPasswordError.textContent = '';
            if (passwordInput.value !== confirmPasswordInput.value) {
                confirmPasswordError.textContent = "¡Las contraseñas no coinciden!";
                event.preventDefault();
                confirmPasswordInput.focus();
                isValid = false;
            }
        });
        function validateConfirmPassword() {
            if (confirmPasswordInput.value && passwordInput.value !== confirmPasswordInput.value) {
                confirmPasswordError.textContent = "¡Las contraseñas no coinciden!";
            } else {
                confirmPasswordError.textContent = '';
            }
        }
        confirmPasswordInput.addEventListener('input', validateConfirmPassword);
        passwordInput.addEventListener('input', validateConfirmPassword);
    }
};

// --- UI TOGGLES & INTERACTION HELPERS ---
window.setupDetailToggle = function setupDetailToggle(checkboxId, detailContainerId, textInputId) {
    const checkbox = document.getElementById(checkboxId);
    const detailContainer = document.getElementById(detailContainerId);
    const textInput = document.getElementById(textInputId);
    if (checkbox && detailContainer) {
        checkbox.addEventListener('change', function () {
            if (this.checked) {
                detailContainer.classList.remove('d-none');
                if (textInput) textInput.focus();
            } else {
                detailContainer.classList.add('d-none');
                if (textInput) textInput.value = '';
            }
        });
        if (checkbox.checked) detailContainer.classList.remove('d-none');
        else detailContainer.classList.add('d-none');
    }
};

window.setupRadioDetailToggle = function setupRadioDetailToggle(radioGroupName, triggerValue, detailContainerId, textInputId) {
    const radioButtons = document.querySelectorAll(`input[type="radio"][name="${radioGroupName}"]`);
    const detailContainer = document.getElementById(detailContainerId);
    const textInput = textInputId ? document.getElementById(textInputId) : null;

    if (radioButtons.length > 0 && detailContainer) {
        function updateDetailVisibility() {
            let showDetail = false;
            radioButtons.forEach(radio => {
                if (radio.checked && radio.value === triggerValue) showDetail = true;
            });
            if (showDetail) {
                detailContainer.classList.remove('d-none');
            } else {
                detailContainer.classList.add('d-none');
                if (textInput) textInput.value = '';
            }
        }
        radioButtons.forEach(radio => radio.addEventListener('change', updateDetailVisibility));
        updateDetailVisibility();
    }
};

// --- CUSTOM FORM ELEMENT SELECTION HANDLERS ---
window.initQuestionOptionSelection = function initQuestionOptionSelection() {
    const containers = document.querySelectorAll('.question-container');
    containers.forEach(container => {
        const optionsInContainer = Array.from(container.querySelectorAll('.question-option'));
        if (optionsInContainer.length === 0) return;
        const selectionMode = container.dataset.selectionMode || 'single';

        if (selectionMode === 'single') {
            optionsInContainer.forEach(option => {
                option.addEventListener('click', function () {
                    optionsInContainer.forEach(opt => opt.classList.remove('selected'));
                    this.classList.add('selected');
                });
            });
        } else if (selectionMode === 'multi') {
            const noAplicaOption = optionsInContainer.find(opt => opt.dataset.value === 'no_aplica');
            const noAplicaCheckbox = noAplicaOption ? noAplicaOption.querySelector('.question-option-checkbox') : null;

            if (noAplicaOption && noAplicaCheckbox) {
                const otherOptions = optionsInContainer.filter(opt => opt !== noAplicaOption);
                optionsInContainer.forEach(option => {
                    const checkbox = option.querySelector('.question-option-checkbox');
                    if (checkbox && checkbox.checked) {
                        option.classList.add('selected');
                        if (option === noAplicaOption) {
                            otherOptions.forEach(opt => {
                                opt.classList.remove('selected');
                                opt.classList.add('disabled-option');
                                const chk = opt.querySelector('.question-option-checkbox');
                                if (chk) { chk.checked = false; chk.disabled = true; }
                            });
                        }
                    }
                });
                optionsInContainer.forEach(option => {
                    option.addEventListener('click', function () {
                        if (this !== noAplicaOption && this.classList.contains('disabled-option')) return;
                        const currentCheckbox = this.querySelector('.question-option-checkbox');
                        const isNAClicked = (this === noAplicaOption);
                        if (isNAClicked) {
                            const isNABecomingActive = !noAplicaOption.classList.contains('selected');
                            noAplicaCheckbox.checked = isNABecomingActive;
                            if (isNABecomingActive) {
                                noAplicaOption.classList.add('selected');
                                noAplicaCheckbox.disabled = false;
                                otherOptions.forEach(opt => {
                                    opt.classList.remove('selected');
                                    opt.classList.add('disabled-option');
                                    const chk = opt.querySelector('.question-option-checkbox');
                                    if (chk) { chk.checked = false; chk.disabled = true; }
                                });
                            } else {
                                noAplicaOption.classList.remove('selected');
                                otherOptions.forEach(opt => {
                                    opt.classList.remove('disabled-option');
                                    const chk = opt.querySelector('.question-option-checkbox');
                                    if (chk) chk.disabled = false;
                                });
                            }
                        } else {
                            if (noAplicaOption.classList.contains('selected')) {
                                noAplicaOption.classList.remove('selected');
                                noAplicaCheckbox.checked = false;
                                otherOptions.forEach(opt => {
                                    opt.classList.remove('disabled-option');
                                    const chk = opt.querySelector('.question-option-checkbox');
                                    if (chk) chk.disabled = false;
                                });
                            }
                            this.classList.toggle('selected');
                            if (currentCheckbox) currentCheckbox.checked = this.classList.contains('selected');
                        }
                        if (typeof window.initBootstrapTooltips === 'function') window.initBootstrapTooltips();
                    });
                });
            } else {
                optionsInContainer.forEach(option => {
                    const checkbox = option.querySelector('.question-option-checkbox');
                    if (checkbox && checkbox.checked) option.classList.add('selected');
                    option.addEventListener('click', function () {
                        this.classList.toggle('selected');
                        if (checkbox) checkbox.checked = this.classList.contains('selected');
                    });
                });
            }
        }
    });
};

window.initBudgetToggle = function initBudgetToggle(inputId, checkboxId) {
    const budgetInput = document.getElementById(inputId);
    const noFixedBudgetCheckbox = document.getElementById(checkboxId);
    if (budgetInput && noFixedBudgetCheckbox) {
        const budgetInputGroup = budgetInput.closest('.input-group');
        function updateBudgetState() {
            if (noFixedBudgetCheckbox.checked) {
                budgetInput.disabled = true;
                budgetInput.value = '';
                if (budgetInputGroup) budgetInputGroup.classList.add('input-group-disabled');
            } else {
                budgetInput.disabled = false;
                if (budgetInputGroup) budgetInputGroup.classList.remove('input-group-disabled');
            }
        }
        noFixedBudgetCheckbox.addEventListener('change', updateBudgetState);
        updateBudgetState();
    }
};

window.initMultiSelectServiceCards = function initMultiSelectServiceCards() {
    const cardOptions = document.querySelectorAll('.card-option');
    cardOptions.forEach(card => {
        const checkbox = card.querySelector('.card-option-checkbox');
        if (!checkbox) return;
        if (checkbox.checked) card.classList.add('selected');
        card.addEventListener('click', function (event) {
            event.preventDefault();
            this.classList.toggle('selected');
            checkbox.checked = this.classList.contains('selected');
        });
    });
};

window.setupExclusiveCheckbox = function setupExclusiveCheckbox(checkboxGroupName, exclusiveCheckboxId) {
    const exclusiveCheckbox = document.getElementById(exclusiveCheckboxId);
    const otherCheckboxes = document.querySelectorAll(`input[type="checkbox"][name="${checkboxGroupName}"]:not(#${exclusiveCheckboxId})`);
    if (!exclusiveCheckbox) return;

    exclusiveCheckbox.addEventListener('change', function () {
        if (this.checked) {
            otherCheckboxes.forEach(cb => {
                cb.checked = false;
                cb.disabled = true;
                if (cb.id === 'accesibilidadOtro' || cb.id === 'atencionMedicaOtroCheck' || cb.id === 'requerimientoEspecificoOtroCheck') {
                    const event = new Event('change', { bubbles: true });
                    cb.dispatchEvent(event);
                }
            });
        } else {
            otherCheckboxes.forEach(cb => { cb.disabled = false; });
        }
    });
    otherCheckboxes.forEach(cb => {
        cb.addEventListener('change', function () {
            if (this.checked) {
                exclusiveCheckbox.checked = false;
                if (!exclusiveCheckbox.checked) {
                    otherCheckboxes.forEach(other_cb => { other_cb.disabled = false; });
                }
            }
        });
    });
};

// ==========================================================================
// GENERAL UI & INITIALIZERS
// ==========================================================================

// --- MODAL LOGIC & CONFETTI ---

// Global confetti particle creator
window.createConfettiParticle = function createConfettiParticle(containerElement) {
    if (!containerElement) return;
    const particle = document.createElement('div');
    particle.classList.add('confetti-particle');
    const colors = ['#f94144', '#f3722c', '#f8961e', '#f9c74f', '#90be6d', '#43aa8b', '#577590', '#277da1', '#ef476f', '#ffd166', '#06d6a0', '#118ab2'];
    particle.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
    const size = Math.random() * 10 + 5;
    particle.style.width = `${size}px`;
    particle.style.height = `${size * (Math.random() * 0.5 + 0.5)}px`;
    particle.style.left = `${Math.random() * 100}%`;
    particle.style.top = `-${size}px`;
    const fallDuration = Math.random() * 2.5 + 2;
    particle.style.animationDuration = `${fallDuration}s`;
    particle.style.transform = `rotate(${Math.random() * 360}deg)`;
    containerElement.appendChild(particle);
    setTimeout(() => {
        if (particle.parentNode) particle.parentNode.removeChild(particle);
    }, fallDuration * 1000 + 500);
};

// Global function to start confetti
window.startConfetti = function startConfetti(numParticles = 60, containerSelector = '#thankYouModal .modal-content') {
    const containerElement = document.querySelector(containerSelector);
    if (!containerElement) {
        console.warn('startConfetti: Container not found:', containerSelector);
        return;
    }
    const currentPosition = window.getComputedStyle(containerElement).position;
    if (currentPosition === 'static') containerElement.style.position = 'relative';
    containerElement.style.overflow = 'hidden'; // Prevent scrollbars during animation
    for (let i = 0; i < numParticles; i++) {
        setTimeout(() => {
            if (typeof window.createConfettiParticle === 'function') {
                window.createConfettiParticle(containerElement);
            }
        }, i * (Math.random() * 40 + 20));
    }
};

// Global function to clear confetti
window.clearConfetti = function clearConfetti(containerSelector = '#thankYouModal .modal-content') {
    const containerElement = document.querySelector(containerSelector);
    if (!containerElement) {
        console.warn('clearConfetti: Container not found:', containerSelector);
        return;
    }
    const particles = containerElement.querySelectorAll('.confetti-particle');
    particles.forEach(p => p.parentNode && p.parentNode.removeChild(p));
    // containerElement.style.overflow = ''; // Optionally reset overflow
};

window.initThankYouModal = function initThankYouModal() {
    const thankYouModalElement = document.getElementById('thankYouModal');
    if (thankYouModalElement) {
        const modalSpinner = document.getElementById('modalSpinner');
        const modalTitleElement = document.getElementById('thankYouModalLabel');
        const modalMainTextElement = document.getElementById('modalMainText');
        const modalCloseButton = document.getElementById('modalCloseButton');
        const celebrationImage = document.getElementById('celebrationImage');

        thankYouModalElement.addEventListener('show.bs.modal', function () {
            if (modalSpinner) modalSpinner.style.display = 'block';
            if (modalCloseButton) modalCloseButton.classList.add('d-none');
            if (modalTitleElement) modalTitleElement.textContent = '¡Muchas Gracias por tus Respuestas!';
            if (modalMainTextElement) modalMainTextElement.textContent = 'Estamos validando tus respuestas para entregarte la mejor ruta.';
            if (celebrationImage) celebrationImage.classList.add('d-none');
            if (typeof window.clearConfetti === 'function') window.clearConfetti();

            setTimeout(function () {
                if (modalSpinner) modalSpinner.style.display = 'none';
                if (modalCloseButton) modalCloseButton.classList.remove('d-none');
                if (modalTitleElement) modalTitleElement.textContent = '¡Felicidades, tus rutas ya se encuentran creadas!';
                if (modalMainTextElement) modalMainTextElement.textContent = '¿De que manera deseas que te contacte un asesor Checkin?';
                if (celebrationImage) celebrationImage.classList.remove('d-none');
                if (typeof window.startConfetti === 'function') window.startConfetti(70);
            }, 3000);
        });
    }
};

// --- NOTIFICATION SYSTEM ---
window.initNotificationControls = function initNotificationControls() {
    const notificationList = document.getElementById('notificationList');
    const markAllAsReadBtn = document.getElementById('markAllAsReadBtn');
    const clearAllNotificationsBtn = document.getElementById('clearAllNotificationsBtn');

    if (!notificationList) {
        if (markAllAsReadBtn) markAllAsReadBtn.style.display = 'none';
        if (clearAllNotificationsBtn) clearAllNotificationsBtn.style.display = 'none';
        return;
    }
    function markAsRead(notificationItem) {
        notificationItem.classList.remove('notification-unread');
        notificationItem.classList.add('notification-read');
    }
    function deleteNotificationItem(item) {
        item.classList.add('notification-deleting');
        item.addEventListener('animationend', () => {
            item.remove();
            updateNotificationAreaState();
        }, { once: true });
    }
    function updateNotificationAreaState() {
        const items = notificationList.querySelectorAll('.list-group-item:not(.notification-deleting)');
        let noNotificationsMessage = notificationList.querySelector('.no-notifications-message');
        if (items.length === 0) {
            if (!noNotificationsMessage) {
                noNotificationsMessage = document.createElement('p');
                noNotificationsMessage.classList.add('text-center', 'text-muted', 'mt-3', 'no-notifications-message');
                noNotificationsMessage.textContent = 'No tienes notificaciones.';
                notificationList.appendChild(noNotificationsMessage);
            }
            if (markAllAsReadBtn) markAllAsReadBtn.style.display = 'none';
            if (clearAllNotificationsBtn) clearAllNotificationsBtn.style.display = 'none';
        } else {
            if (noNotificationsMessage) noNotificationsMessage.remove();
            if (markAllAsReadBtn) markAllAsReadBtn.style.display = '';
            if (clearAllNotificationsBtn) clearAllNotificationsBtn.style.display = '';
        }
    }
    notificationList.addEventListener('click', function (event) {
        const target = event.target;
        const notificationItem = target.closest('.list-group-item');
        if (!notificationItem || notificationItem.classList.contains('notification-deleting')) return;
        if (target.closest('.notification-delete-btn')) {
            deleteNotificationItem(notificationItem);
        } else {
            markAsRead(notificationItem);
        }
    });
    if (markAllAsReadBtn) {
        markAllAsReadBtn.addEventListener('click', function () {
            const unreadItems = notificationList.querySelectorAll('.list-group-item.notification-unread:not(.notification-deleting)');
            unreadItems.forEach(item => markAsRead(item));
        });
    }
    if (clearAllNotificationsBtn) {
        clearAllNotificationsBtn.addEventListener('click', function () {
            const allItems = notificationList.querySelectorAll('.list-group-item:not(.notification-deleting)');
            allItems.forEach(item => deleteNotificationItem(item));
        });
    }
    updateNotificationAreaState();
};

// --- BOOTSTRAP INITIALIZERS ---
window.initBootstrapTooltips = function initBootstrapTooltips() {
    if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
        const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.forEach(function (tooltipTriggerEl) {
            var existingTooltip = bootstrap.Tooltip.getInstance(tooltipTriggerEl);
            if (existingTooltip) existingTooltip.dispose();
            new bootstrap.Tooltip(tooltipTriggerEl);
        });
    }
};

// --- LAYOUT ADJUSTMENTS & MOBILE ENHANCEMENTS ---
window.centerActiveStepOnMobile = function centerActiveStepOnMobile() {
    const stepsContainer = document.querySelector('.steps-container');
    const activeStep = document.querySelector('.step.active');
    if (stepsContainer && activeStep) {
        const containerStyle = window.getComputedStyle(stepsContainer);
        if (containerStyle.overflowX === 'auto' || containerStyle.overflowX === 'scroll') {
            const containerWidth = stepsContainer.offsetWidth;
            const activeStepWidth = activeStep.offsetWidth;
            const activeStepOffsetLeft = activeStep.offsetLeft;
            let targetScrollLeft = activeStepOffsetLeft + (activeStepWidth / 2) - (containerWidth / 2);
            const maxScrollLeft = stepsContainer.scrollWidth - containerWidth;
            targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));
            stepsContainer.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
        }
    }
};

window.initNavbarPaddingAdjustment = function initNavbarPaddingAdjustment() {
    const fixedNavbar = document.querySelector('.navbar.fixed-top');
    const mainContentArea = document.getElementById('content');
    if (fixedNavbar && mainContentArea) {
        function adjustMainContentPadding() {
            const navbarHeight = fixedNavbar.offsetHeight;
            mainContentArea.style.paddingTop = `${navbarHeight}px`;
        }
        adjustMainContentPadding();
        window.addEventListener('resize', adjustMainContentPadding);
    }
};

window.initDurationToggle = function initDurationToggle() {
    const durationInput = document.getElementById('groupCapacity');
    const noAplicaRadio = document.getElementById('duracionNoAplica');
    if (durationInput && noAplicaRadio) {
        const radioGroupName = noAplicaRadio.getAttribute('name');
        if (!radioGroupName) return;
        const allRadiosInGroup = document.querySelectorAll(`input[type="radio"][name="${radioGroupName}"]`);
        function updateDurationInputState() {
            if (noAplicaRadio.checked) {
                durationInput.disabled = true;
                durationInput.value = '';
            } else {
                durationInput.disabled = false;
            }
        }
        allRadiosInGroup.forEach(radio => radio.addEventListener('change', updateDurationInputState));
        updateDurationInputState();
    }
};

// --- APP INITIALIZATION ---
document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.initRegisterFormValidation === 'function') window.initRegisterFormValidation();

    const detailToggleConfigs = [
        { checkboxId: 'conditionOther', detailContainerId: 'otherConditionDetailContainer', textInputId: 'otherConditionText' },
        { checkboxId: 'allergyOtherCheckbox', detailContainerId: 'allergyOtherSpecifyText', textInputId: 'allergyOtherSpecifyText' },
        { checkboxId: 'servicioTipo', detailContainerId: 'servicioTipoDetalle', textInputId: 'servicioTipoTexto' },
        { checkboxId: 'rangoEdadOtro', detailContainerId: 'rangoEdadOtroDetalle', textInputId: 'rangoEdadOtroTexto' },
        { checkboxId: 'servicioOtroCheck', detailContainerId: 'servicioOtroDetalle', textInputId: 'servicioOtroTexto' },
        { checkboxId: 'accesibilidadOtro', detailContainerId: 'accesibilidadOtroDetalle', textInputId: 'accesibilidadOtroTexto' },
        { checkboxId: 'atencionMedicaOtroCheck', detailContainerId: 'atencionMedicaOtroDetalle', textInputId: 'atencionMedicaOtroTexto' },
        { checkboxId: 'actividadOtraCheck', detailContainerId: 'actividadOtraDetalle', textInputId: 'actividadOtraTexto' },
        { checkboxId: 'interaccionCulturalOtraCheck', detailContainerId: 'interaccionCulturalOtraDetalle', textInputId: 'interaccionCulturalOtraTexto' },
        { checkboxId: 'souvenirOtroCheck', detailContainerId: 'souvenirOtroDetalle', textInputId: 'souvenirOtroTexto' },
        { checkboxId: 'mejoraOtroAspecto', detailContainerId: 'mejoraOtroAspectoDetalle', textInputId: 'mejoraOtroAspectoTexto' },
        { checkboxId: 'requerimientoEspecificoOtroCheck', detailContainerId: 'requerimientoEspecificoOtroDetalle', textInputId: 'requerimientoEspecificoOtroTexto' },
        { checkboxId: 'idiomaOtroCheck', detailContainerId: 'idiomaOtroDetalle', textInputId: 'idiomaOtroTexto' }
    ];
    detailToggleConfigs.forEach(config => {
        if (typeof window.setupDetailToggle === 'function') window.setupDetailToggle(config.checkboxId, config.detailContainerId, config.textInputId);
    });

    if (typeof window.initQuestionOptionSelection === 'function') window.initQuestionOptionSelection();
    if (typeof window.initMultiSelectServiceCards === 'function') window.initMultiSelectServiceCards();
    if (typeof window.setupExclusiveCheckbox === 'function') {
        window.setupExclusiveCheckbox('atencion_medica_disponible[]', 'ningunaAtencionMedica');
        window.setupExclusiveCheckbox('requerimientos_especificos[]', 'ningunRequerimientoEspecifico');
        window.setupExclusiveCheckbox('accesos_fisicos[]', 'accesibilidadNinguna');
    }
    if (typeof window.setupRadioDetailToggle === 'function') window.setupRadioDetailToggle('experiencia_previa_pm_pd', 'si', 'experienciaPreviaDetalle', 'experienciaPreviaTexto');
    if (typeof window.initBudgetToggle === 'function') {
        window.initBudgetToggle('daily_budget_food', 'no_fixed_budget_food');
        window.initBudgetToggle('total_budget', 'no_fixed_budget');
    }
    if (typeof window.initDurationToggle === 'function') window.initDurationToggle();
    if (typeof window.initCardSelection === 'function') window.initCardSelection();
    if (typeof window.initNotificationControls === 'function') window.initNotificationControls();
    if (typeof window.initThankYouModal === 'function') window.initThankYouModal();
    if (typeof window.initBootstrapTooltips === 'function') window.initBootstrapTooltips();
    if (typeof window.initNavbarPaddingAdjustment === 'function') window.initNavbarPaddingAdjustment();
    if (typeof window.centerActiveStepOnMobile === 'function') {
        window.centerActiveStepOnMobile();
        window.addEventListener('resize', window.centerActiveStepOnMobile);
    }
});

window.initCardSelection = function initCardSelection() {
    const cardSectionsConfig = [
        { sectionSelector: '.meal-preferences-section', inputId: 'meal_preference_input', noPreferenceValue: 'sin_preferencia_comidas' },
        { sectionSelector: '.climate-preferences-section', inputId: 'climate_preference_input' }
    ];
    cardSectionsConfig.forEach(config => {
        const sectionElement = document.querySelector(config.sectionSelector);
        const effectiveSectionElement = sectionElement || (config.inputId === 'meal_preference_input' ? document.querySelector('#meal_preference_input')?.closest('.question-container.has-cards') : null);
        if (!effectiveSectionElement) return;
        const cardsInGroup = Array.from(effectiveSectionElement.querySelectorAll('.card-option'));
        if (cardsInGroup.length === 0) return;
        const targetInput = document.getElementById(config.inputId);
        if (!targetInput) return;
        const noPreferenceCard = config.noPreferenceValue ? cardsInGroup.find(card => card.dataset.value === config.noPreferenceValue) : null;

        function updateCardStates() {
            const currentValue = targetInput.value;
            cardsInGroup.forEach(card => {
                card.classList.toggle('selected', card.dataset.value === currentValue);
                if (noPreferenceCard) {
                    const isDisabled = currentValue === config.noPreferenceValue && card !== noPreferenceCard;
                    card.classList.toggle('card-option-disabled', isDisabled);
                } else {
                    card.classList.remove('card-option-disabled');
                }
            });
        }
        cardsInGroup.forEach(card => {
            card.addEventListener('click', function () {
                if (this.classList.contains('card-option-disabled')) return;
                const clickedValue = this.dataset.value;
                targetInput.value = (noPreferenceCard && this === noPreferenceCard && this.classList.contains('selected')) ? "" : clickedValue;
                updateCardStates();
            });
        });
        updateCardStates();
    });
};
